<template>
  <div class="home has-background-white-bis fixspace">

    <div class="home-hero image">
      <b-image
        src="https://cdn-musian.imgix.net/The-Piano-Guys-Approved-Image-5-2.jpg"
        :src-fallback="require('@/assets/no-image.png')"
        :srcset-sizes="[400, 800, 1000, 1440]"
        :srcset-formatter="this.formatSrcset"
        alt="Performance of the Day"
        class="performance-photography"
      >
      </b-image>

      <div class="performance-of-the-day gradient is-overlay"></div>
        <section class="hero is-medium">
          <div class="hero-body pb-5">
            <div class="container">
              <div class="columns">
                <div class="column"></div>
                <div class="column hero-text-shadow">
                  <router-link to="video/75woGoJwq2">
                    <p class="has-text-white-bis has-text-weight-bold"
                      style="font-size: 0.9rem;">
                      <span class="hero-subtitle">{{ $t('homeHero.performanceOfTheDay') }}</span>
                    </p>
                    <p class="has-text-weight-bold pb-5"
                      style="font-size: 0.9rem;">
                      <span class="has-text-white-bis hero-subtitle">
                        <span class="has-text-white-bis has-text-weight-normal pr-1">by</span>
                        Piano Guys
                      </span>
                    </p>
                  </router-link>

                  <div v-if="user.loggedIn"
                    class="has-text-black is-size-2 is-size-4-mobile"
                    style="line-height: 1.2; font-weight:900">
                    <p v-if="hours >= 0 && hours <= 4">
                      <span class="hero-title">{{ $t('greet.evening') }}</span>
                    </p>
                    <p v-if="hours > 4 && hours <= 11">
                      <span class="hero-title">{{ $t('greet.morning') }}</span>
                    </p>
                    <p v-if="hours > 11 && hours <= 18">
                      <span class="hero-title">{{ $t('greet.afternoon') }}</span>
                    </p>
                    <p v-if="hours > 18 && hours <= 24">
                      <span class="hero-title">{{ $t('greet.evening') }}</span>
                    </p>
                    <span class="hero-title">{{ $t('greet.welcome') }}</span>
                  </div>
                  <div v-else>
                    <span class="has-text-black is-size-2 is-size-4-mobile hero-title">
                      {{ $t('homeHero.titleFirst') }}
                    </span>
                    <br>
                    <span class="has-text-black is-size-2 is-size-4-mobile hero-title">
                      {{ $t('homeHero.titleSecond') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section">
          <div class="container">
            <vue-horizontal v-if="loadingScenarios" :button="false">
              <div class="topicho" v-for="i in scenarioSkeletonCount" :key="i">
                <div class="card is-shadowless">
                  <div class="card-image">
                    <figure class="image is-1by1 skeleton">
                      <div class="skeleton-block"></div>
                    </figure>
                  </div>
                  <div class="card-content is-overlay"></div>
                </div>
              </div>
            </vue-horizontal>

            <vue-horizontal class="topicHorizontal" v-if="topics.length > 0" :button="true">
              <div class="topicho" v-for="(item, index) in topics" :key="index">
                <router-link :to="'/topics/' + item.id">
                  <div class="card">
                    <div class="card-image">
                      <b-image
                        :src="item.description.image"
                        :alt="item.name"
                        ratio="is-1by1"
                      >
                      </b-image>
                    </div>
                    <div class="card-content is-overlay
                      is-flex is-justify-content-flex-start is-align-items-flex-end p-4"
                      style="background-color: rgba(0,0,0,0.4);">
                      <span class="has-text-white has-text-weight-semibold
                        is-size-5-desktop is-size-6-mobile">
                        {{ item.name }}
                      </span>
                    </div>
                  </div>
                </router-link>
              </div>
            </vue-horizontal>
          </div>
        </section>
    </div>

    <section class="section">
      <div class="container">
        <router-link to="/explore">
        <p class="is-size-4-desktop is-size-6-mobile has-text-weight-semibold has-text-black">
          {{ $t('general.viewallperformance') }}
        </p>
        <p class="is-size-6-desktop is-size-7-mobile has-text-weight-medium has-text-black pt-3">
          {{ $t('general.more') }}<i class="fas fa-long-arrow-alt-right ml-5 mb-5"></i>
        </p>
        </router-link>
        <hr style="border-top:1px solid #000 !important; height:1px !important;">
      </div>
    </section>

    <section class="section pt-0">
      <div class="container">
        <p class="is-size-4-desktop is-size-6-mobile has-text-weight-semibold has-text-black mb-5">
          {{ $t('general.performance') }}
        </p>

        <div
          class="columns is-variable is-1-mobile is-mobile is-multiline"
          v-if="!isTabsDataLoaded"
        >
          <div class="column is-one-quarter-desktop is-one-third-tablet
                  is-half-mobile" v-for="i in skeletonCount" :key="i">
            <div class="media-content">
              <figure class="image is-16by9 skeleton">
                <div class="skeleton-block"></div>
              </figure>
              <div class="pt-1"><b-skeleton></b-skeleton></div>
              <b-skeleton width="30%"></b-skeleton>
            </div>
          </div>
        </div>

        <b-tabs v-model="activeTab"
                class="performanceList"
                @input="onChangeTab"
                v-if="videoTabLists.length > 0"
        >
          <b-tab-item
            :label="$t('general.' + videoTab.name)"
            v-for="(videoTab, tabIndex) in videoTabLists"
            :key="tabIndex"
          >
            <div class="container" v-if="!videoTab.isLoaded">
              <div class="columns is-variable is-1-mobile is-mobile is-multiline">
                <div class="column is-one-quarter-desktop is-one-third-tablet
                  is-half-mobile" v-for="i in skeletonCount" :key="i">
                  <div class="media-content">
                    <figure class="image is-16by9 skeleton">
                      <div class="skeleton-block"></div>
                    </figure>
                    <div class="pt-1"><b-skeleton></b-skeleton></div>
                    <b-skeleton width="30%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-variable is-1-mobile is-mobile is-multiline">
                <div class="column is-one-quarter-desktop is-one-third-tablet
                  is-half-mobile" v-for="item in videoTab.list" :key="item.id">
                  <router-link :to='"/video/" + item.id' :title="item.title">
                    <video-item
                      :channel-title="item.channel.title"
                      :youtube-id="item.provider_video_id"
                      :title="item.title" >
                    </video-item>
                  </router-link>
                </div>
              </div>
            </div>
          </b-tab-item>

        </b-tabs>
      </div>
    </section>

    <section class="hero is-medium has-background-white-ter intro">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-mobile">
            <div class="column">
            </div>
            <div class="column is-hidden-mobile is-hidden-tablet-only">
              <i18n path="msgs.homehero3" tag="h1"
                class="has-text-black is-size-3 pb-5"
                style="line-height: 1.2; font-weight:500;
                  -webkit-writing-mode: vertical-rl; writing-mode: vertical-rl">
                <template v-slot:br><br></template>
              </i18n>
            </div>
            <div class="column is-5">
              <i18n path="msgs.homehero4" tag="h2"
                class="has-text-grey-dark is-size-4-desktop is-size-6-mobile py-6">
                <template v-slot:br><br></template>
              </i18n>
              <router-link to="/submit" aria-label="Contribute">
              <p class="is-size-5 has-text-weight-medium has-text-black is-hidden-mobile pt-6">
                {{ $t('general.submitwork') }}
                <i class="fas fa-arrow-circle-right fa-lg ml-5 mb-5"></i>
              </p>
              </router-link>
            </div>
            <div class="column is-hidden-desktop">
              <i18n path="msgs.homehero3" tag="h1"
                class="has-text-black is-size-5 pb-5"
                style="line-height: 1.2; font-weight:500;
                  -webkit-writing-mode: vertical-rl; writing-mode: vertical-rl">
                <template v-slot:br><br></template>
              </i18n>
            </div>
            <div class="column">
            </div>
          </div>
          <router-link to="/submit" aria-label="Contribute">
          <p class="is-size-6 has-text-weight-medium has-text-black
            is-hidden-desktop is-hidden-tablet-only pt-3">
            {{ $t('general.submitwork') }}<i class="fas fa-arrow-circle-right fa-lg ml-5 mb-5"></i>
          </p>
          </router-link>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <hr class="my-6"
            style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
        <p class="is-size-4-desktop is-size-6-mobile has-text-weight-semibold has-text-black mb-3">
          {{ $t('general.instruments') }}
        </p>
        <p class="is-size-6-desktop is-size-7-mobile">
         {{ $t('msgs.homehero5') }}
        </p>
      </div>
    </section>

    <section class="is-hidden-mobile">
      <div class="container is-fullhd">
        <div class="columns m-0 is-gapless">
          <div class="column" v-for="instruments in instrumentsList" :key="instruments.title">
            <router-link :to="'/instruments/' + instruments.slug">
              <div class="card is-radiusless is-shadowless" style="border-right:1px solid #a3a3a3;">
                <div class="card-image">
                  <b-image
                    :src="'/assets/instruments/home/webp/d_' + instruments.slug + '.webp'"
                    :webp-fallback="'/assets/instruments/home/d_' + instruments.slug + '.jpg'"
                    :alt="instruments.title"
                    ratio="is-3by5"
                  >
                  </b-image>
                </div>
                <div class="card-content is-overlay"
                  style="background-color: rgba(0,0,0,0.5);">
                  <p class="py-5 has-text-white has-text-weight-semibold
                    is-size-4">
                    {{ instruments.title }}
                  </p>
                  <p class="has-text-grey-light is-size-7">
                    {{ instruments.otherTitle }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="is-hidden-desktop is-hidden-tablet-only">
      <div class="container">
        <div class="columns is-gapless">
          <div class="column" v-for="instruments in instrumentsList" :key="instruments.title">
            <router-link :to="'/instruments/' + instruments.slug">
              <div class="card is-radiusless" style="border-top:1px solid #a3a3a3;">
                <div class="card-image">
                  <b-image
                    :src="'/assets/instruments/home/webp/m_' + instruments.slug + '.webp'"
                    :webp-fallback="'/assets/instruments/home/m_' + instruments.slug + '.jpg'"
                    :alt="instruments.title"
                    ratio="is-3by1"
                  >
                  </b-image>
                </div>
                <div class="card-content is-overlay"
                  style="background-color: rgba(0,0,0,0.5);">
                  <p class="py-1 has-text-white has-text-weight-semibold
                    is-size-6">
                    {{ instruments.title }}
                  </p>
                  <p class="has-text-grey-light is-size-7">
                    {{ instruments.otherTitle }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-hidden-touch is-hidden-desktop-only is-hidden-widescreen-only">
      <div class="my-6 is-hidden-mobile"></div>
    </section>

    <section class="section has-background-black-ter">
      <div class="container">
        <hr class="my-6"
            style="border-top:1px solid #fff !important; height:1px !important; width:50px;">
        <router-link to="/about">
          <p class="is-size-5-desktop is-size-6-mobile
            has-text-weight-semibold has-text-white mb-2">
            {{ $t('msgs.homehero6') }}
          </p>
          <p class="is-size-6-desktop is-size-7-mobile
            has-text-weight-medium has-text-white pt-6">
            {{ $t('general.about') }}<i class="fas fa-long-arrow-alt-right ml-5 mb-5"></i>
          </p>
        </router-link>

      </div>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getVideos, getScenarios } from '@/api/api';

const VueHorizontal = () => import('vue-horizontal');

export default {
  name: 'Home',
  components: { VueHorizontal },

  metaInfo() {
    return {
      title: this.$t('title.home'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.home') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      hours: new Date().getHours(),

      isTabsDataLoaded: false,
      activeTab: 0,
      videoTabLists: [],

      skeletonCount: 12,
      limit: 12,
      page: 1,

      topics: [],
      scenarioSkeletonCount: 6,
      loadingScenarios: true,

      instrumentsList: [
        { title: this.$t('instruments.keyboard'), slug: 'keyboard', otherTitle: 'Piano / Accordion / Pipe organ' },
        { title: this.$t('instruments.string'), slug: 'string', otherTitle: 'Violin / Guitar / Harp' },
        { title: this.$t('instruments.wind'), slug: 'wind', otherTitle: 'Flute / Saxophone / Tuba' },
        { title: this.$t('instruments.percussion'), slug: 'percussion', otherTitle: 'Drum / Marimba / Vibraphone' },
      ],
      genreList: [
        { title: this.$t('genre.classical'), slug: 'classical' },
        { title: this.$t('genre.rock'), slug: 'rock' },
        { title: this.$t('genre.pop'), slug: 'pop' },
        { title: this.$t('genre.jazz'), slug: 'jazz' },
      ],
    };
  },

  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },

  created() {
    if (this.$cookies.isKey('home_settings')) {
      const object = this.$cookies.get('home_settings');
      this.getHomeData(object);
      this.isTabsDataLoaded = true;
      this.fetchVideoList(this.activeTab);
    }

    this.$firebase.firestore().collection('settings')
      .doc('home')
      .get()
      .then((snapshot) => {
        const dataObject = snapshot.data();

        if (!this.$cookies.isKey('home_settings')) {
          this.getHomeData(dataObject);
          this.isTabsDataLoaded = true;
          this.fetchVideoList(this.activeTab);
        }

        this.$cookies.set('home_settings', dataObject, 60 * 60 * 24);
      });
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  mounted() {
    this.forGtag();
  },

  methods: {
    getHomeData(dataObject) {
      getScenarios({
        params: { ids: dataObject.featuredScenarios.join(',') },
        headers: { locale: this.$i18n.locale },
      })
        .then((result) => {
          this.topics = result.data.data;
          this.loadingScenarios = false;
        }).catch((err) => { console.error(err); });

      const { videoTabs } = dataObject;

      videoTabs.sort((a, b) => a.sort - b.sort);

      videoTabs.forEach((tab) => {
        this.videoTabLists.push({
          name: tab.name,
          tagName: tab.tagNames,
          isLoaded: false,
          isEmpty: false,
          list: [],
        });
      });
    },
    onChangeTab(tabIndex) {
      this.fetchVideoList(tabIndex);
    },

    fetchVideoList(listIndex) {
      if (this.videoTabLists[listIndex].isLoaded) {
        return;
      }

      const { tagName } = this.videoTabLists[listIndex];
      const params = { limit: this.limit, page: this.page };

      if (tagName === 'recently') {
        params.is_sort_by_counter = 1;
      } else {
        params.tags = tagName;
      }

      getVideos({ params })
        .then((result) => {
          this.videoTabLists[listIndex].list = result.data.data;
          this.videoTabLists[listIndex].isLoaded = true;
        }).catch((err) => { console.error(err); });
    },

    setFallbackImageUrl(event) {
      const id = event.path[0].parentElement.getAttribute('vt-id');
      const image = event.path[0];

      if (image.naturalWidth === 120) {
        image.src = `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
      }
    },

    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.home'));
      }, 500);
    },

    formatSrcset(src, size) {
      const q = 70;
      return `${src}?w=${size}&auto=format&fm=jpg&q=${q}`;
    },
  },
};
</script>

<style lang="scss">
.hero-text-shadow .hero-subtitle {
  line-height: 23px;
  background-color: rgba(0,0,0,0.4);
  padding: 3px 10px;
}
.hero-text-shadow .hero-title {
  font-weight:900;
  line-height: 30px;
  padding: 1px 10px;
  background-color: rgba(250,250,250,0.65);
}
@media screen and (min-width: 769px) {
  .hero-text-shadow .hero-title {
    font-weight:900;
    line-height: 49px;
    padding: 1px 10px;
    background-color: rgba(250,250,250,0.65);
  }
}

.home-hero.image {
  display: inline-block;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.performance-photography {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
}
.performance-photography img {
  height: 100%;
  width: 100%;
}
.performance-of-the-day.gradient {
  background: rgb(250,250,250);
  background: linear-gradient(0deg, rgba(250,250,250,1) 0%, rgba(250,250,250,0) 60%);
}

section.intro {
  background: linear-gradient(
      rgba(0, 0, 0, 0.0),
      rgba(0, 0, 0, 0.0)
    ), url('/assets/introsection_bg.png') no-repeat center top;
  background-size: 600px 231px !important;
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: contain;
  background-size: contain;
}

.tabs a {
  border-bottom: none;
}
.tabs ul {
  border-bottom: none;
}
.tab-content {
  padding: 16px 0 !important;
}
.b-tabs .tabs ul li span {
  color: #888;
}
.b-tabs .tabs ul li.is-active span {
  color: #000;
  font-weight: 600;
}
.performanceList nav.tabs {
  margin-left: -17px;
}

.topicHorizontal .v-hl-btn svg {
  height: 32px;
  width: 32px;
  padding: 6px;
}
.topicho {
  padding: 0px 0px;
  width: 100%;
  margin-right: 24px;
}
@media (min-width: 300px) {
  .topicho {
    width: calc((100% - (24px)) / 2);
  }
}
@media (min-width: 414px) {
  .topicho {
    width: calc((100% - (24px)) / 3);
  }
}
@media (min-width: 768px) {
  .topicho {
    width: calc((100% - (2 * 24px)) / 3);
  }
}
@media (min-width: 1024px) {
  .topicho {
    width: calc((100% - (3 * 24px)) / 4);
  }
}
@media (min-width: 1280px) {
  .topicho {
    width: calc((100% - (4 * 24px)) / 5);
  }
}
</style>
<style scoped>
.genreimage {
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  padding-top: 100%;
  position: relative;
}
.horizontal >>> .v-hl-btn svg {
  height: 32px;
  width: 32px;
  padding: 6px;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  background: linear-gradient(345deg, #00000080 0, #00000060 5%, #00000040 20%, #00000000 50%);
}

.overlay .text {
  line-height: 1;
}
</style>
<style scoped>
.horizontal {
  --count: 2;
  --gap: 16px;
}

@media (min-width: 640px) {
  .horizontal {
    --count: 3;
    --gap: 24px;
  }
}

@media (min-width: 768px) {
  .horizontal {
    --count: 4;
  }
}

@media (min-width: 1024px) {
  .horizontal {
    --count: 4;
  }
}

@media (min-width: 1280px) {
  .horizontal {
    --count: 4;
  }
}

.item {
  width: calc((100% - ((var(--count) - 1) * var(--gap))) / var(--count));
  margin-right: var(--gap);
}
</style>
